import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    GetEngagePosts,
    CreateEngagePost,
    UpdateEngagePost,
    DeleteEngagePost,
    AddPostReaction,
    AddPostComment,
    DeletePostComment
} from "../../helpers/api_method";

export const fetchEngagePosts = createAsyncThunk("engage/fetchEngagePosts", async (params: any = {}, { rejectWithValue }) => {
    try {
        const response = await GetEngagePosts(params);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to fetch engage posts' });
    }
});

export const createEngagePost = createAsyncThunk("engage/createEngagePost", async (data: any, { rejectWithValue }) => {
    try {
        const response = await CreateEngagePost(data);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to create engage post' });
    }
});

export const deleteEngagePost = createAsyncThunk("engage/deleteEngagePost", async (postId: string, { rejectWithValue }) => {
    try {
        const response = await DeleteEngagePost(postId);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to delete engage post' });
    }
});

export const updateEngagePost = createAsyncThunk("engage/updateEngagePost", async (data: any, { rejectWithValue }) => {
    try {
        const response = await UpdateEngagePost(data.id, data);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to update engage post' });
    }
});

export const addPostReaction = createAsyncThunk("engage/addPostReaction", async (data: any, { rejectWithValue }) => {
    try {
        const response = await AddPostReaction(data);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to add post reaction' });
    }
});

export const addPostComment = createAsyncThunk("engage/addPostComment", async (data: any, { rejectWithValue }) => {
    try {
        const response = await AddPostComment(data);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to add post comment' });
    }
});

export const deletePostComment = createAsyncThunk("engage/deletePostComment", async (commentId: string, { rejectWithValue }) => {
    try {
        const response = await DeletePostComment(commentId);
        return response;
    } catch (error: any) {
        return rejectWithValue({ error: error.message || 'Failed to delete post comment' });
    }
});


